export const colours = {
  accent: '#7328F0',
  accentLight: '#13CAE2',
  darkGray: '#222222',
  black: '#141C3A',
};
